import { useAppDispatch } from "../redux/store/hooks";
import { feedFilterSubmit } from "../redux/actions";
import { ConfigProvider, DatePicker, Radio, RadioChangeEvent } from "antd";
import locale from "antd/es/date-picker/locale/ru_RU";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";

const Calendar: React.FC = () => {
  const dispatch = useAppDispatch();
  //dispatch(resetFeedFilter());
  const { RangePicker } = DatePicker;
  const [value, setValue] = useState("today");
  const feedFilter = useSelector(getFeedFilter);
  const [tonality, setTonality] = useState(feedFilter.tonal);
  const [repostOption, setRepostOption] = useState(feedFilter.repostoption);
  const [friendly, setFriendly] = useState(feedFilter.friendly);
  const [sorting, setSorting] = useState(feedFilter.sort);
  const [dateString, setDateString] = useState<any>([
    new Date().toJSON().split("T")[0],
    new Date().toJSON().split("T")[0],
  ]);
  const options = [
    { label: " Другое", value: "period" },
    { label: "Сегодня", value: "today" },
    { label: "7д", value: "week" },
    { label: "1м", value: "month" },
  ];
  const [source, setSource] = useState({
    smi: feedFilter.smi,
    vk: feedFilter.vk,
    tg: feedFilter.tg,
    yt: feedFilter.yt,
    dz: feedFilter.dz,
    ok: feedFilter.ok,
  });

  useEffect(() => {
    dispatch(
      feedFilterSubmit({
        from: dateString[0]?.slice(0, 10) + " 00:00:00",
        to: dateString[1]?.slice(0, 10) + " 23:59:59",
        smi: source.smi,
        vk: source.vk,
        tg: source.tg,
        yt: source.yt,
        ok: source.ok,
        tonal: tonality,
        friendly: friendly,
        sorting: sorting,
        profile_id: [],
        repostoption: repostOption,
      })
    );
  }, [dateString]);

  const onChange = ({ target: { value } }: RadioChangeEvent) => {
    setValue(value);
    if (value == "today")
      setDateString([
        new Date().toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    if (value == "week") {
      const start = new Date();
      start.setDate(start.getDate() - 6);
      setDateString([
        start.toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    }
    if (value == "month") {
      const start = new Date();
      start.setDate(start.getDate() - 29);
      setDateString([
        start.toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    }
  };

  const onPeriodChange = (value: any, dateString: string[]): void => {
    setDateString([
      dateString[0]?.split(".")[2] +
        "-" +
        dateString[0]?.split(".")[1] +
        "-" +
        dateString[0]?.split(".")[0],
      dateString[1]?.split(".")[2] +
        "-" +
        dateString[1]?.split(".")[1] +
        "-" +
        dateString[1]?.split(".")[0],
    ]);
  };

  return (
    <div className="flex clear margin-bottom">
      <ConfigProvider
        theme={{
          components: {
            Radio: {
              buttonSolidCheckedColor: "#7856FE",
              buttonSolidCheckedBg: "rgba(0, 0, 0, 0.1)",
              colorPrimary: "rgba(0, 0, 0, 0.1)",
              buttonSolidCheckedHoverBg: "rgba(0, 0, 0, 0.2)",
            },
          },
        }}
      >
        <Radio.Group
          options={options}
          onChange={onChange}
          value={value}
          optionType="button"
          buttonStyle="solid"
          //disabled={isLoading}
        />
      </ConfigProvider>

      {value == "period" && (
        <RangePicker
          format={{
            format: "DD.MM.YYYY",
          }}
          onChange={onPeriodChange}
          style={{ width: "278px" }}
          className="choose-period"
          allowClear={false}
          locale={locale}
        />
      )}
    </div>
  );
};

export default Calendar;
